import {useEffect} from "react";
import "./MemberPage.css";

export function _DotsPagination({units, onUnitClick, currentUnitIndex}) {
    const handleDotClick = (index) => {
        onUnitClick(index);
    };

    const dotStyle = (index) => ({
        width: `${currentUnitIndex === index ? 1.2 : 1}em`,
        height: `${currentUnitIndex === index ? 1.2 : 1}em`,
        borderRadius: "50%",
        marginTop: index === 0 ? 0 : 20,
        padding: 8,
        backgroundColor: currentUnitIndex === index ? "var(--bs-primary)" : "var(--not-selected)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        position: "relative"
    });

    const dotContainerStyle = {
        position: "fixed",
        top: "50%",
        left: "7em",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10
    };

    return (
        <div style={dotContainerStyle}>
            {units.map((unit, index) => (
                <div
                    key={unit}
                    style={dotStyle(index)}
                    onClick={() => handleDotClick(index)}
                    title={`${unit}로 이동`}
                />
            ))}
        </div>
    );
}